import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { Floor } from '../../interfaces/api/floor';
import { fetchFloors, fetchFloorsSearchFilter } from '../services/floors.service';
import { FloorSearchFilterParam } from '../../api/floors';

interface FloorState {
	floors: {
		[id: number]: Floor;
	};
	isLoading: boolean;
}

const initialState = {
	floors: [],
	isLoading: false,
} as FloorState;

export const fetchFloorsThunk = createAsyncThunk<Floor[], void>(
	'floor/fetchFloors',
	async (_undefined, { rejectWithValue }) => {
		try {
			return await fetchFloors();
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);

export const fetchFloorSearchFilterThunk = createAsyncThunk<
	Floor[],
	{ params: FloorSearchFilterParam }
>('floor/fetchFloorsSearchFilter', async ({ params }, { rejectWithValue }) => {
	try {
		return await fetchFloorsSearchFilter(params);
	} catch (error) {
		return rejectWithValue(error);
	}
});

const floorSlice = createSlice({
	name: 'floor',
	initialState,
	reducers: {
		resetFloor: (state) => {
			Object.assign(state, initialState);
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchFloorsThunk.fulfilled, (state, action) => {
			const ret: { [id: number]: Floor } = {};
			state.floors = action.payload.reduce((obj, floor) => {
				obj[floor.id] = floor;
				return obj;
			}, ret);
			state.isLoading = false;
		});
		builder.addCase(fetchFloorsThunk.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchFloorsThunk.rejected, (state, action) => {
			state.floors = [];
			state.isLoading = false;
		});

		builder.addCase(fetchFloorSearchFilterThunk.fulfilled, (state, action) => {
			const ret: { [id: number]: Floor } = {};
			state.floors = action.payload.reduce((obj, floor) => {
				obj[floor.id] = floor;
				return obj;
			}, ret);
			state.isLoading = false;
		});
		builder.addCase(fetchFloorSearchFilterThunk.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchFloorSearchFilterThunk.rejected, (state, action) => {
			state.floors = [];
			state.isLoading = false;
		});
	},
});

export const { resetFloor } = floorSlice.actions;

export default floorSlice;
